<template>
  <a-card :bordered="false">
    <div style="font-weight: bold;font-size: 18px;margin-bottom: 10px;">店铺授权码（绑定）</div>
    <div style="margin-bottom: 10px;">{{ details.authCode }}
      <a style="margin-left: 15px;color:black;" @click="onCopy">复制</a>
      <a-popconfirm title="是否要解除绑定？" @confirm="unBindEvent">
        <a style="margin-left: 15px">解除绑定</a>
      </a-popconfirm>
    </div>
    <div class="title">使用说明：</div>
    <div class="text">1、复制“店铺授权码”后，前往对应的魔方系统；</div>
    <div class="text">2、在魔方系统“服务-我的服务”中找到“飞猪直连”，进入添加授权码信息；</div>
    <div class="text">3、添加授权成功后刷新本页面，即可绑定成功；</div>
    <div class="title">补充说明：</div>
    <div class="text">1、本应用仅用于绑定关联店铺，不提供其他业务操作功能；</div>
    <div class="text">2、商品同步设置、价格设置等，均在魔方系统“服务-我的服务”-“飞猪直连”中；</div>
    <div class="text">3、若您尚未开通魔方系统，可联系右侧千牛客服开通；</div>
  </a-card>
</template>

<script>
export default {
  name: 'AuthorizationCode',
  props: {
    details: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      code: '',
      submitLoading: false
    }
  },

  created() {
    this.code = this.getPageParams().code
  },
  mounted() {
  },
  methods: {
    onCopy(e) {
      this.$copyText(this.details.authCode).then(message => {
        this.getLogUtils().logWithTag('copy', message)
        this.$message.success('复制完毕')
      }).catch(err => {
        this.getLogUtils().logWithTag('copy.err', err)
        this.$message.error('复制失败')
      })
    },
    onError(e) {
      this.$message.error('复制失败')
    },
    //解除绑定
    unBindEvent() {
      if (this.submitLoading) {
        return
      }
      this.submitLoading = true
      const params = {
        id: this.details.authId
      }
      this.getHttpServices().getServerApiService().post('feizhu/taobao/removeAuthCodeBind', params)
        .then(authCode => {
          this.$message.success('解除绑定成功')
          this.$emit('unBindSuccess', authCode)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.submitLoading = false)
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  margin: 20px 0 10px;
  font-size: 16px;
  font-weight: bold;
}

.text {
  margin-bottom: 10px;
}
</style>